module.exports = __webpack_public_path__ + "media/images/icons/outlined/double-right-f74610adec559152145b61de061d6170.svg";